var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuickLinks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Home_-_Quick_Links",
    "data-name": "Home - Quick Links",
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.297,
    height: 61.296,
    viewBox: "0 0 61.297 61.296",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M27.379,1.362A1.362,1.362,0,0,0,26.017,0H1.362A1.362,1.362,0,0,0,0,1.362V26.017a1.362,1.362,0,0,0,1.362,1.362H26.017a1.362,1.362,0,0,0,1.362-1.362ZM24.655,24.655H2.724V2.724h21.93Zm0,0",
    fill: "#009639"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M338.629,1.362A1.362,1.362,0,0,0,337.267,0H312.612a1.362,1.362,0,0,0-1.362,1.362V26.017a1.362,1.362,0,0,0,1.362,1.362h24.655a1.362,1.362,0,0,0,1.362-1.362ZM335.9,24.655h-21.93V2.724H335.9Zm0,0",
    transform: "translate(-277.332)",
    fill: "#009639"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M27.379,312.612a1.362,1.362,0,0,0-1.362-1.362H1.362A1.362,1.362,0,0,0,0,312.612v24.655a1.362,1.362,0,0,0,1.362,1.362H26.017a1.362,1.362,0,0,0,1.362-1.362Zm-2.724,23.156H2.724V313.974h21.93Zm0,0",
    transform: "translate(0 -277.333)",
    fill: "#009639"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M338.629,312.612a1.362,1.362,0,0,0-1.362-1.362H312.612a1.362,1.362,0,0,0-1.362,1.362v24.655a1.362,1.362,0,0,0,1.362,1.362h24.655a1.362,1.362,0,0,0,1.362-1.362ZM335.9,335.768h-21.93V313.974H335.9Zm0,0",
    transform: "translate(-277.332 -277.333)",
    fill: "#009639"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickLinks);
export default __webpack_public_path__ + "static/media/QuickLinks.7d24c081c7016ab27f746824ef472142.svg";
export { ForwardRef as ReactComponent };